var map = {
	"./Benefit-uprating-25.md": 96698,
	"./analysing-autumn-budget-universal-credit-reforms-with-policyengine.md": 98584,
	"./analysis-of-guaranteed-income-for-the-21st-century.md": 95375,
	"./analysis-of-the-spring-budget-2023.md": 48354,
	"./api-v2.md": 88769,
	"./april-1st-2025.md": 91290,
	"./auto-loan-drafting-error.md": 82508,
	"./automate-policy-analysis-with-policy-engines-new-chatgpt-integration.md": 54503,
	"./autumn-budget-2024-employer-nic-pension-contributions.md": 69508,
	"./autumn-budget-2024-policy-choices.ipynb": 49214,
	"./autumn-budget-24-employer-ni.md": 78742,
	"./autumn-budget-24-fuel-duty.md": 28235,
	"./autumn-statement-2023.md": 94840,
	"./behavioural-responses.md": 76689,
	"./biden-budget-2025.md": 22365,
	"./breaking-down-policy-impacts-by-wealth-decile.md": 89876,
	"./breaking-down-uk-poverty-impacts-by-sex.md": 58683,
	"./breaking-down-us-poverty-impacts-by-sex.md": 97647,
	"./building-the-roots-of-policyengine-nigeria.md": 13607,
	"./california-income-tax.md": 3999,
	"./cgt-autumn-budget.md": 93810,
	"./charitable-contributions.md": 50091,
	"./citizens-economic-council.md": 96576,
	"./computing-your-oregon-earned-income-tax-credit.md": 1751,
	"./conservative-2024-manifesto.md": 64712,
	"./dc-financial-support-for-families-with-children.md": 13363,
	"./digital-public-goods-alliance-recognizes-policyengine-as-a-digital-public-good.md": 65594,
	"./district-child-tax-credit.md": 4796,
	"./earth-day-2025.md": 23820,
	"./electric-vehicle-tax-credits-under-current-law-and-the-inflation-reduction-act.md": 1359,
	"./enhanced-cps-beta.md": 9633,
	"./enhancing-the-current-population-survey-for-policy-analysis.md": 9208,
	"./estimating-your-supplemental-security-income-benefits-in-policyengine.md": 98306,
	"./family-first-act.md": 80666,
	"./farage-speech-may-2025.ipynb": 66237,
	"./federal-tax-inflation-adjustments-2025.md": 14855,
	"./fisc-act.md": 41854,
	"./fiscalsim.md": 62930,
	"./from-idea-to-impact-scoring-a-policy-reform-on-the-new-policyengine-uk.md": 14526,
	"./from-idea-to-impact-scoring-a-policy-reform-on-the-new-policyengine-us.md": 64267,
	"./from-openfisca-to-policyengine.md": 76806,
	"./givecalc.md": 30393,
	"./gpt-analysis.md": 38474,
	"./harris-ctc.md": 34238,
	"./harris-eitc.md": 62451,
	"./hmt-policyengine-pilot.md": 36024,
	"./how-developers-can-explore-the-policyengine-api.md": 16622,
	"./how-machine-learning-tools-make-policyengine-more-accurate.md": 43054,
	"./how-policyengine-estimates-the-effects-of-uk-carbon-taxes.md": 63400,
	"./how-to-simulate-basic-and-guaranteed-income-policies-in-policyengine-us.md": 32377,
	"./how-would-reforms-affect-cliffs.md": 50721,
	"./idaho-2025-tax-change.ipynb": 80195,
	"./impact-of-tax-changes-2025-2026.md": 64178,
	"./impact-of-the-chancellors-cost-of-living-support-package.md": 68682,
	"./income-tax-cuts-rishi-sunak-is-reportedly-considering.md": 39664,
	"./income-tax-freeze.md": 42042,
	"./introducing-2024-election-calculator.md": 97112,
	"./introducing-salternative.md": 14084,
	"./introducing-utah-state-income-tax-analysis-on-policyengine.md": 90865,
	"./kansas-flat-income-tax-sb-169.md": 18192,
	"./kansas-income-tax.md": 50840,
	"./kentucky-cuts-income-tax-rate.md": 11536,
	"./labour-2024-manifesto.md": 75317,
	"./lib-dem-2024-manifesto.md": 14123,
	"./lift-act.md": 87845,
	"./louisiana-flat-tax.md": 44053,
	"./make-everyone-a-policymaker.md": 65732,
	"./malliotakis-steel-working-families-tax-cut-act.md": 73139,
	"./managers-amendment-to-hr1.md": 92249,
	"./maryland-standard-deduction.md": 61349,
	"./massachusetts-governor-maura-healeys-fy-2024-budget-recommendation.md": 56917,
	"./medlock-donation-calculator.md": 56436,
	"./medlock-wins.md": 58376,
	"./michigan-bill-hb4170.ipynb": 70618,
	"./mn-hf1938-walz.md": 88777,
	"./montana-tax-cuts-2026.md": 15397,
	"./myfriendben-nc.md": 52881,
	"./neo-philanthropy.md": 51022,
	"./new-mexico-income-tax-launch.md": 76244,
	"./new-york-tanf.md": 83138,
	"./niskanen-center-analysis.md": 32763,
	"./northern-ireland-feasibility.ipynb": 50631,
	"./nta-2024.md": 90045,
	"./ny-hochul-budget.md": 44808,
	"./ny-wftc.md": 89595,
	"./nyc-ctc-s2238.md": 97023,
	"./obr-forecast-2025.ipynb": 91088,
	"./obr-forecast-update-spring-24.ipynb": 9701,
	"./openfisca-wins-edge-of-government-innovation-award.md": 87030,
	"./oregon-rebate.md": 65758,
	"./oregons-nonrefundable-exemption-credit.md": 41945,
	"./pip-and-freeze.md": 40145,
	"./policyengine-2022-year-in-review.md": 53842,
	"./policyengine-at-the-basic-income-guarantee-conference-and-the-beeck-centers-rules-as-code-demo-day.md": 16490,
	"./policyengine-comes-stateside.md": 91389,
	"./policyengine-launches-in-new-york-state.md": 31977,
	"./policyengine-launches-in-washington-state.md": 48202,
	"./policyengines-2021-year-in-review.md": 46522,
	"./poverty-race-ethnicity.md": 29710,
	"./prime-minister-liz-trusss-energy-bill-price-cap.md": 99572,
	"./projected-impact-of-the-uks-extended-energy-price-guarantee.md": 20379,
	"./raising-the-marriage-allowance-from-10-to-100.md": 96708,
	"./reform-uks-emergency-recovery-plan.md": 27575,
	"./rent-relief-act.md": 90862,
	"./repealing_the_two_child_limit.md": 40858,
	"./restoration-of-the-american-rescue-plan-acts-expanded-child-tax-credit.md": 50820,
	"./restoring-arpa-eitc.md": 92079,
	"./rishi-sunaks-proposal-to-cut-the-basic-rate-to-16-percent.md": 33044,
	"./salt-caucus-62k-cap.md": 6945,
	"./school-vat.md": 10263,
	"./social-security-tax-exemption.md": 59359,
	"./spring-budget-2024.ipynb": 14395,
	"./stamp-duties-in-policyengine-uk.md": 11788,
	"./state-tax-model-beta.md": 42586,
	"./tax-cuts-in-prime-minister-trusss-growth-plan.md": 18187,
	"./tcja-extension.md": 83934,
	"./the-child-tax-credit-in-2023.md": 41475,
	"./the-green-party-manifesto-at-policyfest.md": 59458,
	"./the-new-policyengine-us-population-impact-page.md": 70199,
	"./trafwa-ctc.md": 26407,
	"./trump-2024.md": 10828,
	"./uk-2024-spring-budget.ipynb": 36198,
	"./uk-benefits-post.md": 49592,
	"./uk-calibration-2023-q4.ipynb": 61214,
	"./uk-childcare-report.md": 95790,
	"./uk-household-ai.md": 63454,
	"./uk-nuffield-grant.md": 78949,
	"./uk-pip-reforms.md": 24742,
	"./uk-spi-validation.ipynb": 55806,
	"./uk-taxes-post.md": 94694,
	"./uk-the-new-policyengine.md": 78758,
	"./uk-triple-lock-plus.ipynb": 16071,
	"./uk-year-in-review-2024.md": 41588,
	"./updating-policyengine-to-reflect-snap-reform-in-the-omnibus-bill.md": 72851,
	"./us-behavioral-responses.md": 31389,
	"./us-household-ai.md": 54059,
	"./us-the-new-policyengine.md": 98502,
	"./us-year-in-review-2024.md": 78725,
	"./utah-income-tax-changes.ipynb": 26291,
	"./vance-ctc.md": 6196,
	"./vat-school-comparison.md": 77029,
	"./ways-and-means-salt-cap.md": 97643,
	"./winship-individualized-eitc.md": 47231,
	"./wyden-smith-ctc.md": 75467,
	"./young-child-exemption-two-child-limit.md": 27063
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81562;